import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'gbc-form-hint',
    templateUrl: './form-hint.component.html',
    styleUrls: ['./form-hint.component.scss'],
    standalone: true
})
export class FormHintComponent {
}
